import { Icons } from "@/icons/icons"
import { ContextMenu, ContextMenuItemModel } from "@syncfusion/ej2-vue-grids"
import { computed, ComputedRef, ref } from "vue"

interface PropsUseExtraFilters {
  contextMenuRef: ComputedRef<InstanceType<typeof ContextMenu> | null>
}

interface ResponseUseExtraFilters {
  extraFilters: ComputedRef<any>
  setExtraFilter: (value: any, filtro: string) => void
  setItemSelected: (id: string, value: any) => ContextMenuItemModel[]
}

export default function useExtraFilters(props: PropsUseExtraFilters): ResponseUseExtraFilters {
  const { contextMenuRef } = props

  const filters = ref<any>({})

  const extraFilters = computed(() => {
    return {
      ...filters.value
    }
  })

  const setExtraFilter = (value: any, filter: string) => {
    setItemSelected(filter, value)

    filters.value = {
      ...filters.value,
      [filter]: value
    }
  }

  function setItemSelected(id: string, value: any) {
    const contextMenu = contextMenuRef.value as any;
    const items = contextMenu.items
    const itemChanged = items.find((item: any) => item.id === id).items.forEach((item: any) => {
      item.iconCss = item.actionType === value ? Icons.RADIO_ACTIVE : Icons.CIRCLE_O
    })
    return [...items, itemChanged]
  }

  return {
    setItemSelected,
    extraFilters,
    setExtraFilter
  }
}
